
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/games/stacknload/login",
      function () {
        return require("private-next-pages/games/stacknload/login.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/games/stacknload/login"])
      });
    }
  